import { createContext } from "react";

const RoutineContext = createContext();


export default RoutineContext;